/* eslint-disable react-hooks/exhaustive-deps */
import React, { forwardRef, useEffect, useRef, useState } from 'react';

/** Common Components */
import MolGrid from '../../components/Grid/MolGrid'

/** Configuration Files */
import AllInterviewConfig from './allInterviewList.data';

/** RTK Query */
import { useGetScheduleInterviewListMutation } from '../../app/services/candidateAPI';

/** CSS FilesF */
import "./AllInterview.scss";

const AllInterviewList = forwardRef((props, ref) => {

  const molGridRef = useRef();
  const [listData, setListData] = useState();
  const [totalRowCount, setTotalRowCount] = useState(0);

  const [getScheduleInterviewList, {
    isLoading,
    isSuccess,
    data: interviewListData
  }] = useGetScheduleInterviewListMutation();

  const getLists = (pageObject) => {
    getScheduleInterviewList(pageObject)
  }

  const handlePageChange = (page) => {
    const request = {
      pagination: { pageNumber: page.pageNumber, pageSize: page.pageSize },
      filters: { searchText: props.search }
    };
    getLists(request);
  };

  useEffect(() => {
    if (isSuccess && interviewListData) {
      if (interviewListData) {
        setListData(interviewListData.dataSource)
      }
      if (interviewListData.totalRecord) {
        setTotalRowCount(interviewListData.totalRecord)
      }
    }
  }, [isSuccess, interviewListData]);

  useEffect(() => {
    if (molGridRef.current) {
      const currentPageObject = molGridRef.current.getCurrentPageObject();
      const request = {
        pagination: { pageNumber: currentPageObject.pageNumber, pageSize: currentPageObject.pageSize },
        filters: { searchText: props.search },
      };
      getLists(request);
    }
  }, [props.search]);

  return (
    <div className="all-interview-table">
      <div className="table-body-scroll">
        <MolGrid
          ref={molGridRef}
          configuration={AllInterviewConfig}
          dataSource={listData}
          allowPagination={true}
          pagination={{
            totalCount: totalRowCount,
            pageSize: 20,
            currentPage: 1,
          }}
          isLoading={isLoading}

          onPageChange={handlePageChange}
        />
      </div>
    </div>
  )
})

export default AllInterviewList